import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '.../../environments/environment'
import { Broadcaster } from '.../../environments/broadcaster'
import { AuthService } from '../../../_services/index'
import { LoaderService } from 'app/_services/loader.service'
import { utils, write, WorkBook } from 'xlsx'
import { saveAs } from 'file-saver'
import Swal from 'sweetalert2'
import { vehicleHistoryService } from './vehicleHistory.service'
declare var $: any

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css'],
})
export class VehicleComponent implements OnInit {
  map: any
  showLoader: boolean
  public Id
  public data
  public userId: any
  public areaEntityData
  public staffEntityData
  public prjData
  public vehNo
  public VehiclesByID
  public VehiclesDataStatus
  selectedRow: Number
  selectedAreaRow: Number
  setClickedRow: Function
  selectAreaEntityDetailsRow: Function
  //selectStaffEntityDetailsRow :Function;
  public vehiclesCatogery
  public vehiclesArealabel: any
  public stdate: any
  public enddate: any
  public selectPrjId: any
  public SelectVehno: any
  public deleted = false
  public delwarning = false
  public updtVehDataSuccess = false
  public VehicleParkLocation: any
  public selectProjectmodel: any
  public vehAreaModel: any
  public vehiclesAreaEntity: any
  public vehAssignmtStaffRole: any
  public vehStaffRoleModel: any
  public staffRole: any
  public staffNameData: any
  public areaAssignDetails: any
  public staffAssignDetails: any
  public vehStaffNameModel: any
  public vehStaffAsignStatus: any
  search: any
  showDialog: any
  visible: any
  //---------------vehicles Update Details-------------
  //For Update validations
  public udptVehTypename = false
  public updtImeiNo = false
  public udptParkLocation = false
  public udptDataStatus = false
  public saveAreaEntityStatus = false
  public saveStaffNameStatus = false
  public deleteAreaEntity = false
  public vehStaffRoleStatus = false
  public vehStaffRoleNameStatus = false
  public isVehAssignSave = false
  public isStaffAssignSave = false
  public vehiclesNo: any
  public vehTypId: any
  public vehType: any
  public vehCotegaryId: any
  public vehiclesType: any
  public inActiveVehiclesLst: any
  public SelectProjectName: any
  public vehCotId: any
  public vehTypeId: any
  public VehiclesNo: any
  public imeidNo: any
  public chaChihNo: any
  public vtsMobileNo: any
  public simNo: any
  public vtsModel: any
  public parkLocations: any
  public installDate: any
  public activationsDate: any
  public vehDataStatus: any
  public isjingleActive: any
  public isActiveStatus: any
  public selectedRowData: any
  public Prjid: any
  public updtCheckVehnoAvl: any
  public updtCheckVehMobileImeiNoAvl: any
  public updtCheckVtsMobileNoAvt: any
  public updtCheckVehChasisNoAvt: any
  public updtCheckSimNoAvt: any
  public vehCatArea: any
  public vehlabelId: any
  public vehEntityArea = false
  public vehStaffStatus = false
  public vehAreaEntityModel: any
  public vehEntityData: any
  public vehAreaAsignStatus: any
  public vehStaffRoleId: any
  public project: any
  public updateData: any
  public updtVstDeviceNo: any
  public updtGsmOperator: any
  public updtEntryDate: any
  public currentDate: any
  public projectMaster: any
  public showHideVehAssignLoadDiv = false
  public showHideStaffAssignLoadDiv = false
  public imageVehAssignLoader: any
  public imageStaffAssignLoader: any
  public vehUpdateBtnDiv = false
  public vehDeleteBtnDiv = false
  public vehAssignmentBtnDiv = false
  public vehActiveBtnDiv = false
  public showHideVehNoDiv = false
  public isVehicleUpdtbtn = false
  public showHideImeiNoDiv = false
  public imgVehNoPath: any
  public imgVehImeiNoPath: any
  public showHideChasisNoDiv: any
  public imgChasisNoPath: any
  public imgVtsMobilNoPath: any
  public showHideVtsMobileDiv = false
  public imgSimNoPath: any
  public showHideSimNoDiv = false
  public employeeRecordNotFound = false
  public vehAreaRecordNotFound = false
  public staffAssignReNotFound = false
  public vehID: any
  //public staffSelectionsId:any;
  public vtsModalaData: any
  public vtsData: any
  public vehOwnerTypeList: any
  public ownerType: any
  public VehiclesTempNo: any
  public vehOwnerTypeData: any
  public ownerNameModal: any
  public vtsModal: any
  public vehOwnerRequired = false
  public vtsModelRequired = false
  public updtResponceMsg: any
  public updtVehDataError = false
  public saveAreaEntityError = false
  public saveStaffNameError = false
  routeBoundary
  changeStatus: any
  status: any
  titleData: any
  successMsg: any
  currentVehicleId: any
  driverHistoryData: any
  routeSelected: boolean
  beatDetails: any
  beatName: any
  routeDetails: any
  isBeatNull: boolean
  routeList: any
  isRouteSelected: boolean
  singleRouteDetails: any
  isNameUpdating: boolean
  routeName: any
  updateNameSuccess: boolean
  updateNameError: boolean
  selectedRouteId: any
  VehRunningBy: any
  primaryCount: number
  secondarycount: number
  EcoGreenvehcleCountData: number
  ContractorvehcleCountData: number
  withSimNumber: any
  withoutSimNumber: any
  VtsServicesValue: any
  VtsServicesVehicleId: any
  vtsServiceSuccess: boolean
  selected: boolean
  selectedEnabled: boolean
  selectedDisabled: boolean
  vehprojectTypeList: { ID: string; VALUE: string }[]
  locationIdChange: any
  vehprojectTypeListModal: string
  reason: any
  vehStatus: any
  ActiveInactiveModal: any
  constructor(
    private http: HttpClient,
    private broadcaster: Broadcaster,
    private auth: AuthService,
    private loaderService: LoaderService,
    private vehService: vehicleHistoryService,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
    this.vehOwnerTypeList = [
      { ID: 1, VALUE: 'Ecogreen' },
      { ID: 2, VALUE: 'Contractor' },
    ]

    this.vehprojectTypeList = [
      { ID: '1', VALUE: 'LUCKNOW' },
      { ID: '2', VALUE: 'GURUGRAM' },
      { ID: '3', VALUE: 'FARIDABAD' },
      { ID: '4', VALUE: 'GWALIOR' },
    ]
  }
  ngOnInit(): void {
    var myOptions = {
      center: new google.maps.LatLng(28.47769599987369, 77.06160699973178),
      zoom: 13,
      panControl: true,
      mapTypeControl: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        position: google.maps.ControlPosition.TOP_LEFT,
      },
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM,
        style: google.maps.ZoomControlStyle.SMALL,
      },
      // fullscreenControlOptions: {
      //   position: google.maps.ControlPosition.TOP_CENTER,
      //   style: google.maps.ControlPosition.SMALL
      // }
    }
    this.map = new google.maps.Map(document.getElementById('map'), myOptions)

    this.broadcaster.on('vehicleInserted').subscribe((message) => {
      this.allVehicles()
    })
    $('#progress-bar').hide()
    this.Prjid = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    if (this.Prjid == 1) {
      this.SelectProjectName = 'LUCKNOW'
    } else if (this.Prjid == 2) {
      this.SelectProjectName = 'GURUGRAM'
    } else if (this.Prjid == 3) {
      this.SelectProjectName = 'FARIDABAD'
    } else if (this.Prjid == 4) {
      this.SelectProjectName = 'GWALIOR'
    }
    this.getAllVehiclesAreaLable(this.Prjid)
    // this.allVehicles();
    // this.activeVehicles()
    // this.getAllVehiclesDetails(1)
    this.getAllVehiclesDetails()
    this.getAllStaffRoleByPrjId(this.Prjid)
    this.getVehiclesParkLocations(this.Prjid)
    this.getVehiclesDataStatus()
    this.getVtsModalData()
    this.getAllVehiclesCategory()
    this.getAllVehiclesType(1)
    this.getVehiclesParkLocations(this.Prjid)
  }

  //Get the All vehicles Catogery details.
  getAllVehiclesCategory() {
    this.http
      .get(environment.apiUrl + 'admin/getVehiclesCatogeryType')
      .subscribe((data) => {
        this.vehiclesCatogery = data
      })
  }
  //###############################get All Active and Inactive Vehicles List START###############################//

  allVehicles() {
    this.vehActiveBtnDiv = false
    this.vehUpdateBtnDiv = true
    this.vehDeleteBtnDiv = true
    this.vehAssignmentBtnDiv = true
    this.loaderService.display(true)

    $('button').click(function () {
      $(this)
        .addClass('btn-primary')
        .removeClass('btn-default')
        .siblings()
        .removeClass('btn-primary')
        .addClass('btn-default')
    })

    this.http
      .get(
        environment.apiUrl +
          'admin/getAllVehiclesByProject?prjid=' +
          this.Prjid,
      )
      .subscribe((data) => {
        this.data = data

        if (this.data.length == 0) {
          this.employeeRecordNotFound = true
        }
        if (this.data.length != 0) {
          this.employeeRecordNotFound = false
        }
        this.loaderService.display(false)
      })
  }
  getTotalCountVehicle(data) {
    console.log('279', data)

    this.primaryCount
    this.secondarycount
    this.EcoGreenvehcleCountData
    this.ContractorvehcleCountData

    this.primaryCount = data.filter(function (element) {
      return element.vehcatname == 'Primary'
    }).length

    this.secondarycount = data.filter(function (element) {
      return element.vehcatname == 'Secondary'
    }).length

    this.EcoGreenvehcleCountData = data.filter(function (element) {
      return element.OWNERTYPE == 'Ecogreen'
    }).length

    this.ContractorvehcleCountData = data.filter(function (element) {
      return element.OWNERTYPE == 'Contractor'
    }).length

    this.withSimNumber = data.filter(function (element) {
      return element.vtsMobileno != ''
    }).length

    this.withoutSimNumber = data.filter(function (element) {
      return element.OWNERTYPE == ''
    }).length
  }
  //Active Vehicles;
  // activeVehicles() {
  //   $('button').click( function() {
  //     $(this).addClass('btn-primary').removeClass('btn-default').siblings().removeClass('btn-primary').addClass('btn-default');
  //   });
  //   this.vehActiveBtnDiv = false;
  //   this.vehUpdateBtnDiv = true;
  //   this.vehDeleteBtnDiv = true;
  //   this.vehAssignmentBtnDiv = true;
  //   this.getAllVehiclesDetails(this.Prjid);
  // }

  /*
   * get all Vehicle List
   */
  // getAllVehiclesDetails(pageNumber) {
  getAllVehiclesDetails() {
    this.loaderService.display(true)
    $('button').click(function () {
      $(this)
        .addClass('btn-primary')
        .removeClass('btn-default')
        .siblings()
        .removeClass('btn-primary')
        .addClass('btn-default')
    })
    this.vehActiveBtnDiv = false
    this.vehUpdateBtnDiv = true
    this.vehDeleteBtnDiv = true
    this.vehAssignmentBtnDiv = true
    this.http
      .get(environment.apiUrl + 'admin/getVehicalsDetails?prjid=' + this.Prjid)
      .subscribe((data) => {
        this.data = data

        this.getTotalCountVehicle(data)

        if (this.data.length > 0) {
          this.employeeRecordNotFound = false
          this.loaderService.display(false)
        } else {
          this.employeeRecordNotFound = true
          this.loaderService.display(false)
        }
      })
  }

  inActiveVehicles() {
    $('button').click(function () {
      $(this)
        .addClass('btn-primary')
        .removeClass('btn-default')
        .siblings()
        .removeClass('btn-primary')
        .addClass('btn-default')
    })
    this.vehActiveBtnDiv = true
    this.vehUpdateBtnDiv = false
    this.vehDeleteBtnDiv = false
    this.vehAssignmentBtnDiv = false
    this.loaderService.display(true)
    this.http
      .get(
        environment.apiUrl + 'admin/getAllInactiveVehicles?prjid=' + this.Prjid,
      )
      .subscribe((data) => {
        this.inActiveVehiclesLst = data
        this.data = this.inActiveVehiclesLst
        if (this.inActiveVehiclesLst.length == 0) {
          this.employeeRecordNotFound = true
        }
        if (this.inActiveVehiclesLst.length != 0) {
          this.employeeRecordNotFound = false
        }
        this.loaderService.display(false)
      })
  }

  // pageChanged(event){
  //   this.getAllVehiclesDetails(event)
  // }

  //###############################Inactive Vehicles List END###############################//

  //To change the Vehicles Type as per Vehicles Categary chnage event
  SelectVehiclesTypeName() {
    var selectCotegaryID = this.vehCotId
    this.getAllVehiclesType(selectCotegaryID)
  }

  //To get vehicles Type Name into the Add new Vehicleas
  getAllVehiclesType(selectCotegaryID) {
    this.http
      .get(
        environment.apiUrl + 'admin/getVehiclesType?catId=' + selectCotegaryID,
      )
      .subscribe((data) => {
        this.vehiclesType = data
      })
  }
  //To select The Parking locations accroding to the selected Project ID
  getVehiclesParkLocations(Prjid) {
    this.http
      .get(
        environment.apiUrl +
          'admin/getVehiclesParkingLocations?prjid=' +
          this.Prjid,
      )
      .subscribe((data) => {
        this.VehicleParkLocation = data
      })
  }

  getVehiclesDataStatus() {
    this.http
      .get(environment.apiUrl + 'admin/getVehiclesStatus')
      .subscribe((data) => {
        this.VehiclesDataStatus = data
      })
  }
  //=============================Blur Method availibility validations on Updated Model popup=================================//

  onBlurToCheckVehNoExistUpdt() {
    if (
      this.VehiclesNo == null ||
      this.VehiclesNo == undefined ||
      this.VehiclesNo == ''
    ) {
      this.showHideVehNoDiv = false
      this.isVehicleUpdtbtn = true
      return
    }
    this.showHideVehNoDiv = true
    this.imgVehNoPath = '../../assets/img/loading.gif'
    this.http
      .get(
        environment.apiUrl +
          'admin/checkVehNoAvailability?vehiclesNo=' +
          this.VehiclesNo,
      )
      .subscribe((data) => {
        this.updtCheckVehnoAvl = data
        if (this.updtCheckVehnoAvl[0].result == 'Available') {
          this.isVehicleUpdtbtn = false
          this.showHideVehNoDiv = true
          this.imgVehNoPath = '../../assets/img/ok.png'
        }
        if (this.updtCheckVehnoAvl[0].result == 'All ready exist') {
          this.isVehicleUpdtbtn = true
          this.showHideVehNoDiv = true
          this.imgVehNoPath = '../../assets/img/wrong.jpg'
        }
      })
  }

  //Check avialibility for Imei No
  onBlurToCheckimeImeiNoExistUpdt() {
    if (
      this.imeidNo == null ||
      this.imeidNo == undefined ||
      this.imeidNo == ''
    ) {
      this.showHideImeiNoDiv = false
      this.isVehicleUpdtbtn = false
      return
    }
    this.showHideImeiNoDiv = true
    this.imgVehImeiNoPath = '../../assets/img/loading.gif'
    this.http
      .get(
        environment.apiUrl +
          'admin/checkVehMobileImeiAvailability?IMEI=' +
          this.imeidNo,
      )
      .subscribe((data) => {
        this.updtCheckVehMobileImeiNoAvl = data
        if (this.updtCheckVehMobileImeiNoAvl[0].result == 'Available') {
          this.isVehicleUpdtbtn = false
          this.showHideImeiNoDiv = true
          this.imgVehImeiNoPath = '../../assets/img/ok.png'
        }
        if (this.updtCheckVehMobileImeiNoAvl[0].result == 'All ready exist') {
          this.isVehicleUpdtbtn = true
          this.showHideImeiNoDiv = true
          this.imgVehImeiNoPath = '../../assets/img/wrong.jpg'
        }
      })
  }

  //To check Chasis No availability
  onBlurToCheckChasisNoExistUpdt() {
    if (
      this.chaChihNo == null ||
      this.chaChihNo == undefined ||
      this.chaChihNo == ''
    ) {
      this.showHideChasisNoDiv = false
      this.isVehicleUpdtbtn = false
      return
    }
    this.showHideChasisNoDiv = true
    this.imgChasisNoPath = '../../assets/img/loading.gif'
    this.http
      .get(
        environment.apiUrl +
          'admin/checkVehChasisNoAvailability?CHASISNO=' +
          this.chaChihNo,
      )
      .subscribe((data) => {
        this.updtCheckVehChasisNoAvt = data
        if (this.updtCheckVehChasisNoAvt[0].result == 'Available') {
          this.isVehicleUpdtbtn = false
          this.showHideChasisNoDiv = true
          this.imgChasisNoPath = '../../assets/img/ok.png'
        }
        if (this.updtCheckVehChasisNoAvt[0].result == 'All ready exist') {
          //this.isVehicleUpdtbtn=true;
          this.showHideChasisNoDiv = true
          this.imgChasisNoPath = '../../assets/img/wrong.jpg'
        }
      })
  }

  //To check VTS Mobile No availability
  onBlurToCheckVtsMobileNoExistUpdt() {
    if (
      this.vtsMobileNo == null ||
      this.vtsMobileNo == undefined ||
      this.vtsMobileNo == ''
    ) {
      this.showHideVtsMobileDiv = false
      this.isVehicleUpdtbtn = false
      return
    }
    this.showHideVtsMobileDiv = true
    this.imgVtsMobilNoPath = '../../assets/img/loading.gif'
    this.http
      .get(
        environment.apiUrl +
          'admin/checkVtsMobileAvailability?VTSMOBILENO=' +
          this.vtsMobileNo,
      )
      .subscribe((data) => {
        this.updtCheckVtsMobileNoAvt = data
        if (this.updtCheckVtsMobileNoAvt[0].result == 'Available') {
          this.isVehicleUpdtbtn = false
          this.showHideVtsMobileDiv = true
          this.imgVtsMobilNoPath = '../../assets/img/ok.png'
        }
        if (this.updtCheckVtsMobileNoAvt[0].result == 'All ready exist') {
          this.isVehicleUpdtbtn = true
          this.showHideVtsMobileDiv = true
          this.imgVtsMobilNoPath = '../../assets/img/wrong.jpg'
        }
      })
  }

  //To check VTS Mobile No availability
  onBlurToCheckVtsMobSimNoExistUpdt() {
    if (this.simNo == null || this.simNo == undefined || this.simNo == '') {
      this.showHideSimNoDiv = false
      this.isVehicleUpdtbtn = false
      return
    }
    this.showHideSimNoDiv = true
    this.imgSimNoPath = '../../assets/img/loading.gif'
    this.http
      .get(
        environment.apiUrl + 'admin/checkSimNoAvailability?SIM=' + this.simNo,
      )
      .subscribe((data) => {
        this.updtCheckSimNoAvt = data
        if (this.updtCheckSimNoAvt[0].result == 'Available') {
          this.isVehicleUpdtbtn = false
          this.showHideSimNoDiv = true
          this.imgSimNoPath = '../../assets/img/ok.png'
        }
        if (this.updtCheckSimNoAvt[0].result == 'All ready exist') {
          //this.isVehicleUpdtbtn=true;
          this.showHideSimNoDiv = true
          this.imgSimNoPath = '../../assets/img/wrong.jpg'
        }
      })
  }

  /*
   * Update Vehicle Details Opem Modal popup
   */
  updateVehicle(data) {
    this.Id = data.ID
    this.vehCotId = data.vehCatId
    if (this.vehCotId == 1) {
      this.vehCatArea = 'Primary'
    }
    if (this.vehCotId == 2) {
      this.vehCatArea = 'Secondary'
    }
    this.vehTypeId = data.vehtypid
    this.VehiclesNo = data.vehno
    this.imeidNo = data.imei
    this.chaChihNo = data.chasisNo
    this.vtsMobileNo = data.vtsMobileno
    this.simNo = data.SIM
    this.parkLocations = data.parkLocId
    this.installDate = data.installdt
    this.activationsDate = data.activedt
    this.isActiveStatus = data.isactive
    if (this.isActiveStatus == 'Active') {
      this.isActiveStatus = true
    }
    if (this.isActiveStatus == 'InActive') {
      this.isActiveStatus = false
    }
    this.vehDataStatus = data.dataStatusId
    this.isjingleActive = data.jinglestatus
    if (data.vtsmodel == 'RP01N') {
      this.vtsModal = 1
    } else if (data.vtsmodel == 'RP05') {
      this.vtsModal = 2
    } else if (data.vtsmodel == 'EMPTY') {
      this.vtsModal = 3
    }
    if (data.OWNERTYPE == 'Ecogreen') {
      this.vehOwnerTypeData = 1
    } else if (data.OWNERTYPE == 'Contractor') {
      this.vehOwnerTypeData = 2
    }
    this.VehiclesTempNo = data.VEHTEMPNO
    this.ownerNameModal = data.OWNERNAME
    this.updtVehDataError = false
    this.updtVehDataSuccess = false
    $('#exampleModal').modal('show')
    this.isVehicleUpdtbtn = false
    this.showHideVehNoDiv = false
    this.showHideImeiNoDiv = false
    this.showHideChasisNoDiv = false
    this.showHideVtsMobileDiv = false
    this.showHideSimNoDiv = false
    this.vtsModelRequired = false
    this.vehOwnerRequired = false
  }
  /*
   * Update Vehicle Details
   */

  onClickToUpdateVehiclesDetails() {
    var activeStatus
    var jingalStatus
    if (this.isActiveStatus == true) {
      activeStatus = 1
    }
    if (this.isjingleActive == true) {
      jingalStatus = 1
    }
    if (this.vtsModal == '1') {
      this.vtsModal = 'RP01N'
    } else if (this.vtsModal == '2') {
      this.vtsModal = 'RP05'
    } else if (this.vtsModal == '3') {
      this.vtsModal = 'EMPTY'
    }
    if (this.vehOwnerTypeData == '1') {
      this.vehOwnerTypeData = 'Ecogreen'
    } else if (this.vehOwnerTypeData == '2') {
      this.vehOwnerTypeData = 'Contractor'
    }
    if (this.vehOwnerTypeData == null || this.vehOwnerTypeData == undefined) {
      this.vehOwnerRequired = true
      return
    }
    if (this.vtsModal == null || this.vtsModal == undefined) {
      this.vtsModelRequired = true
      return
    }
    this.currentDate = new Date()
    var jsonUpdateData = {
      ID: this.Id,
      PRJID: this.Prjid,
      VEHNO: this.VehiclesNo,
      VEHTEMPNO: this.VehiclesTempNo,
      VEHTYPID: this.vehTypeId ? this.vehTypeId : null,
      CHASISNO: this.chaChihNo,
      VTSDEVICENO: this.updtVstDeviceNo ? this.updtVstDeviceNo : null,
      VTSMOBILENO: this.vtsMobileNo ? this.vtsMobileNo : null,
      IMEI: this.imeidNo ? this.imeidNo : null,
      SIM: this.simNo,
      VTSMODEL: this.vtsModal ? this.vtsModal : null,
      GSMOPERATOR: this.updtGsmOperator ? this.updtGsmOperator : '',
      PARKLOCID: this.parkLocations ? this.parkLocations : null,
      INSTALLDT: this.installDate ? this.installDate : this.currentDate,
      ACTIVEDT: this.activationsDate ? this.activationsDate : this.currentDate,
      JINGLESTATUS: jingalStatus ? jingalStatus : 0,
      DATASTATUS: this.vehDataStatus ? this.vehDataStatus : 0,
      ISACTIVE: activeStatus ? activeStatus : 0,
      ENTRYDT: '',
      UPDATEDT: this.currentDate,
      USERID: this.userId,
      OWNERTYPE: this.vehOwnerTypeData,
      OWNERNAME:
        this.vehOwnerTypeData == 'Ecogreen' && this.VehRunningBy == 'Ecogreen'
          ? 'Ecogreen'
          : this.ownerNameModal,
      VehicleRunningBy: this.VehRunningBy,
    }

    console.log('573', jsonUpdateData)

    this.isVehicleUpdtbtn = true
    this.loaderService.display(true)
    this.http
      .post(environment.apiUrl + 'admin/updateVehiclesDetails', jsonUpdateData)
      .subscribe((data) => {
        this.updateData = data
        // console.log("updateData",this.updateData)
        if (this.updateData.output[0].RESPONSECODE == 200) {
          this.updtVehDataError = false
          this.updtResponceMsg = this.updateData.output[1].RESPONSEMESSAGE
          this.updtVehDataSuccess = true
          this.allVehicles()
          setTimeout(() => {
            $('#exampleModal').modal('hide')
            this.updtVehDataSuccess = false
            this.isVehicleUpdtbtn = false
            this.loaderService.display(false)
          }, 1000)
        } else {
          this.updtVehDataError = true
          this.updtResponceMsg = this.updateData.output[1].RESPONSEMESSAGE
          this.isVehicleUpdtbtn = false
          this.loaderService.display(false)
        }
      })

    //  update data in firestore data base start
    this.vehService.updateVehicleDoc(jsonUpdateData)
    //  update data in firestore data base end
  }

  clearAllfields() {
    this.vehCotId = null
    this.vehTypeId = null
    this.VehiclesTempNo = null
    this.imeidNo = null
    this.chaChihNo = null
    this.vtsMobileNo = null
    this.simNo = null
    this.parkLocations = null
    this.vehDataStatus = null
    this.VehiclesNo = null
    this.ownerNameModal = null
  }

  //==============To delete the VEhicles Details START===============================//
  onClickToDeleteVehicles() {
    this.http
      .get(
        environment.apiUrl +
          'admin/deleteVehiclesDetails?vehiclesNo=' +
          this.VehiclesNo,
      )
      .subscribe((data) => {
        this.data = data
        this.deleted = true
        setTimeout(() => {
          this.deleted = false
          $('#myModal').modal('hide')
        }, 1000)
      })
    this.allVehicles()
  }
  //==============To delete the VEhicles Details END====================================== =//

  //===========================================For Vehicles Assigmant Details Code Start(13_03_2018)===========================================//
  //Get the All vehicles Area label details.
  getAllVehiclesAreaLable(prjid) {
    this.http
      .get(environment.apiUrl + 'admin/getAllVehicalAreaByPrjId?prjid=' + prjid)
      .subscribe((data) => {
        this.vehiclesArealabel = data
      })
  }

  //on change the Area label and select the Label cotegory Entity Name details..
  OnChangeAreaLabelGetEntity() {
    this.isRouteSelected = false
    this.vehlabelId = this.vehAreaModel
    this.getAllVehiclesAreaEntityByOemId(this.vehlabelId, this.Prjid)
    if (
      this.vehAreaModel == null ||
      this.vehAreaModel == undefined ||
      this.vehAreaModel == '' ||
      this.vehAreaModel == 'null'
    ) {
      this.isVehAssignSave = true
      this.vehEntityArea = true
      this.showHideVehAssignLoadDiv = false
    } else {
      this.vehEntityArea = false
      this.isVehAssignSave = true
      this.showHideVehAssignLoadDiv = false
    }

    if (this.vehAreaModel == 10) {
      this.isRouteSelected = true
      var isZoneAssigned: boolean
      var isWardAssigned: boolean
      for (let i = 0; i < this.areaAssignDetails.length; i++) {
        if (this.areaAssignDetails.find((e) => e.OEMNAME == 'ZONE')) {
          isZoneAssigned = true
        }
        if (this.areaAssignDetails.find((e) => e.OEMNAME == 'WARD')) {
          isWardAssigned = true
        }
      }

      if (!isWardAssigned && !isZoneAssigned) {
        alert('Please assign areas first!')
        this.isRouteSelected = false
        return false
      } else {
        if (!isZoneAssigned) {
          alert('Please assign zone first!')
          return false
        }
        if (!isWardAssigned) {
          alert('Please assign ward first!')
          return false
        }
      }

      this.isRouteSelected = true
    } else {
      this.isRouteSelected = false
    }
  }
  //To check the Avialability of Vehicles avaibility
  OnChangeToGetEntityId() {
    if (
      this.vehAreaEntityModel == null ||
      this.vehAreaEntityModel == undefined ||
      this.vehAreaModel == null ||
      this.vehAreaModel == undefined
    ) {
      this.showHideVehAssignLoadDiv = false
      this.vehStaffStatus = false
      this.isVehAssignSave = true
      return
    }
    this.showHideVehAssignLoadDiv = true
    this.imageVehAssignLoader = '../../assets/img/loading.gif'
    this.vehEntityData = this.vehAreaEntityModel
    this.http
      .get(
        environment.apiUrl +
          'admin/getVehicalAssignAvailability?VEHID=' +
          this.Id +
          '&ENTITYID=' +
          this.vehEntityData,
      )
      .subscribe((data) => {
        this.vehAreaAsignStatus = data
        if (this.vehAreaAsignStatus[0].result == 'Available') {
          this.isVehAssignSave = false
          this.vehStaffStatus = false
          this.imageVehAssignLoader = '../../assets/img/ok.png'
        }
        if (this.vehAreaAsignStatus[0].result == 'Already exists') {
          this.isVehAssignSave = false
          this.vehStaffStatus = false
          this.isVehAssignSave = true
          this.imageVehAssignLoader = '../../assets/img/wrong.jpg'
        }
      })
  }

  OnBeatChange() {
    this.isBeatNull = this.beatName == null ? true : false
    this.http
      .get(
        environment.apiUrl +
          'admin/getRouteByBeat?prnid=' +
          this.beatName +
          '&prjid=' +
          this.Prjid,
      )
      .subscribe((data) => {
        this.routeDetails = data
        console.log(this.routeDetails)

        if (this.routeDetails.entityData.length > 0) {
          this.routeList = this.routeDetails.entityData
          this.plotRoute()
        } else {
          alert('No route found for this beat.')
          this.isBeatNull = true
          return false
        }
      })
  }

  plotRoute() {
    this.clearRoute()
    if (this.routeDetails) {
      this.map.data.addGeoJson(this.routeDetails.geoJson)
      this.zoom(this.map, true)
      this.setStyle(this)
      this.loaderService.display(false)
    } else {
      alert(
        'Please wait while the data is being fetched. This may take upto one minute. Thank You!',
      )
      this.routeBoundary = false
      this.loaderService.display(false)
    }
  }

  clearRoute() {
    this.map.data.forEach((feature) => {
      if (feature.getProperty('Oemid') == '10') {
        this.map.data.remove(feature)
      }
    })
    this.loaderService.display(false)
  }

  async onRouteChange() {
    this.loaderService.display(true)
    this.isVehAssignSave =
      this.vehAreaEntityModel == null ||
      this.vehAreaEntityModel == '' ||
      this.vehAreaEntityModel == undefined
        ? true
        : false
    this.clearRoute()
    if (
      this.vehAreaEntityModel == null ||
      this.vehAreaEntityModel == '' ||
      this.vehAreaEntityModel == undefined
    ) {
      this.OnBeatChange()
    } else {
      this.getRoute(this.vehAreaEntityModel)
    }
  }

  getRoute(data) {
    this.clearRoute()
    this.http
      .get(
        environment.apiUrl +
          'admin/getSingleRoute?entityname=' +
          data +
          '&prjid=' +
          this.Prjid,
      )
      .subscribe((data) => {
        console.log(data)

        this.singleRouteDetails = data
        this.selectedRouteId = this.singleRouteDetails['entityData'][0]['id']
        this.map.data.addGeoJson(this.singleRouteDetails.geoJson)
        this.zoom(this.map, true)
        this.setStyle(this)
        this.loaderService.display(false)
      })
  }

  updateRoute() {
    this.isNameUpdating = this.isNameUpdating ? false : true
    console.log(this.routeName)
  }

  updateRouteName() {
    var zoneData = this.areaAssignDetails.find((e) => e.OEMNAME == 'ZONE')
    var wardData = this.areaAssignDetails.find((e) => e.OEMNAME == 'WARD')
    var zoneNumber = zoneData.ENTITYNAME.substring(
      zoneData.ENTITYNAME.lastIndexOf('-') + 1,
    )
    var wardNumber = wardData.ENTITYNAME.substring(
      wardData.ENTITYNAME.lastIndexOf('-') + 1,
    )
    var data = {
      name: 'Z' + zoneNumber + 'W' + wardNumber + '-' + this.routeName,
      entityName: this.vehAreaEntityModel,
    }
    this.http
      .post(environment.apiUrl + 'admin/updateRouteName', data)
      .subscribe((data) => {
        var updateData: any = data
        if (updateData.status == 'ok') {
          this.updateNameSuccess = true
          setTimeout(() => {
            this.updateNameSuccess = false
          }, 1000)
          this.OnBeatChange()
        } else {
          this.updateNameError = true
          setTimeout(() => {
            this.updateNameSuccess = false
          }, 1000)
        }
      })
  }

  //Get the All vehicles Area label details.
  getAllVehiclesAreaEntityByOemId(vehlabelId, Prjid) {
    this.http
      .get(
        environment.apiUrl +
          'admin/getAllVehicalAreaEntityByOemId?oemid=' +
          vehlabelId +
          '&PRJID=' +
          this.Prjid,
      )
      .subscribe((data) => {
        this.vehiclesAreaEntity = data
      })
  }
  //Get the All vehicles Area label details.
  getAllStaffRoleByPrjId(Prjid) {
    this.http
      .get(
        environment.apiUrl +
          'admin/getAllStaffRoleNameByPrjId?prjid=' +
          this.Prjid,
      )
      .subscribe((data) => {
        this.vehAssignmtStaffRole = data
      })
  }
  //Get the All vehicles Area label details.

  formatDriverData(data) {
    for (var i = 0; i < data.length; i++) {
      data[i].empname = data[i].empname + ' ( ' + data[i].EMPCODE + ' )'
    }

    return data
  }

  getAllStaffNameByRoleId(staffRole) {
    this.http
      .get(
        environment.apiUrl +
          'admin/getAllStaffNameByRoleId?roleid=' +
          this.staffRole,
      )
      .subscribe((data) => {
        this.staffNameData = this.formatDriverData(data)
      })
  }

  //To Get the Area Assignment Details and bind Table for Area Assignment
  getAllAreaAssignmentDetails(Id) {
    this.http
      .get(environment.apiUrl + 'admin/getAreaAssignmentDetails?VEHID=' + Id)
      .subscribe((data) => {
        this.areaAssignDetails = data
        if (this.areaAssignDetails.length == 0) {
          this.vehAreaRecordNotFound = true
        } else {
          this.vehAreaRecordNotFound = false
          this.getBeatData(
            this.areaAssignDetails.find((e) => e.OEMNAME == 'WARD'),
          )
        }
      })
  }

  // get beat data
  getBeatData(wardName) {
    this.http
      .get(
        environment.apiUrl +
          'admin/getBeatDataByWard?prjid=' +
          this.Prjid +
          '&wardName=' +
          wardName.ENTITYNAME,
      )
      .subscribe((data) => {
        this.beatDetails = data
      })
  }

  //To Get the Area Assignment Details and bind Table for Staff Assignment
  getAllStaffAssignmentDetails(Id) {
    this.http
      .get(environment.apiUrl + 'admin/getStaffAssignmentDetails?VEHID=' + Id)
      .subscribe((data) => {
        this.staffAssignDetails = data
        if (this.staffAssignDetails.length == 0) {
          this.staffAssignReNotFound = true
        } else {
          this.staffAssignReNotFound = false
        }
      })
  }

  //To save the Area Asign Entity Data into the VEHENTITYMAP Table
  //selectedRouteId

  onClickToSaveVehRouteDeta() {
    this.currentDate = new Date()
    var activeStatus
    this.isVehAssignSave = true
    if (this.activeStatus == 'Active') {
      activeStatus = 1
    }
    if (this.vehAreaModel == null || this.vehAreaModel == undefined) {
      this.vehEntityArea = true
      return
    }
    if (
      this.vehAreaEntityModel == null ||
      this.vehAreaEntityModel == undefined
    ) {
      this.vehStaffStatus = true
      return
    }
    console.log(this.vehEntityData)

    var jsonAreaEntityData = {
      VEHID: this.Id,
      ENTITYID: this.selectedRouteId,
      ASSIGNDT: this.currentDate,
      ISACTIVE: activeStatus ? activeStatus : 0,
      ENTRYDT: this.currentDate,
      USERID: this.userId,
    }

    this.http
      .post(
        environment.apiUrl + 'admin/saveVehAreaAssignDetails',
        jsonAreaEntityData,
      )
      .subscribe((data) => {
        this.updateData = data
        if (this.updateData.status == 'ok') {
          this.saveAreaEntityStatus = true
          this.getAllAreaAssignmentDetails(this.Id)
          setTimeout(() => {
            this.saveAreaEntityStatus = false
            this.showHideVehAssignLoadDiv = false
            this.vehAreaModel = null
            this.vehAreaEntityModel = null
            this.selectedRouteId = null
          }, 2000)
        } else {
          this.saveAreaEntityError = true
        }
      })
  }

  onClickToSaveVehEntityDeta() {
    this.currentDate = new Date()
    var activeStatus
    this.isVehAssignSave = true
    if (this.activeStatus == 'Active') {
      activeStatus = 1
    }
    if (this.vehAreaModel == null || this.vehAreaModel == undefined) {
      this.vehEntityArea = true
      return
    }
    if (
      this.vehAreaEntityModel == null ||
      this.vehAreaEntityModel == undefined
    ) {
      this.vehStaffStatus = true
      return
    }
    console.log(this.vehEntityData)

    var jsonAreaEntityData = {
      VEHID: this.Id,
      ENTITYID: this.vehEntityData,
      ASSIGNDT: this.currentDate,
      ISACTIVE: activeStatus ? activeStatus : 0,
      ENTRYDT: this.currentDate,
      USERID: this.userId,
    }

    console.log(jsonAreaEntityData)

    this.http
      .post(
        environment.apiUrl + 'admin/saveVehAreaAssignDetails',
        jsonAreaEntityData,
      )
      .subscribe((data) => {
        this.updateData = data
        if (this.updateData.status == 'ok') {
          this.saveAreaEntityStatus = true
          this.getAllAreaAssignmentDetails(this.Id)
          setTimeout(() => {
            this.saveAreaEntityStatus = false
            this.showHideVehAssignLoadDiv = false
            this.vehAreaModel = null
            this.vehAreaEntityModel = null
          }, 2000)
        } else {
          this.saveAreaEntityError = true
        }
      })

    //   assignement data in firestore database starts

    this.vehService.assignmentDoc(jsonAreaEntityData)

    //   assignement data in firestore database end
  }

  /*
   * Delete Assign Modal popup windows
   */
  deleteAssignAreaPopup(item) {
    // console.log("data",item)
    this.vehID = item.ID
  }

  /*
   * Delete Assign Area
   */
  deleteAssignArea() {
    this.http
      .get(
        environment.apiUrl +
          'admin/deleteVehicleAreaEntityDetails?VEHID=' +
          this.vehID,
      )
      .subscribe((data) => {
        var updatedData: any
        updatedData = data
        if (updatedData.status == 'ok') {
          this.deleteAreaEntity = true
          setTimeout(() => {
            this.getAllAreaAssignmentDetails(this.Id)
            this.deleteAreaEntity = false
            $('#myAreaEntityModel').modal('hide')
          }, 1000)
        } else {
          this.delwarning = true
        }
      })
  }

  //on click to select The Row Vehid according to the Row click
  // setClkSelectStaffDetailsRow(){
  //   this.selectStaffEntityDetailsRow = function(staffEntityData){
  //     this.staffSelectionsId=staffEntityData.id;
  //   }
  // }

  removeStaffAssignment(item) {
    // console.log("sfatt assign",item)
    this.vehID = item.id
  }

  removeStaffAssign() {
    this.http
      .get(
        environment.apiUrl +
          'admin/deleteVehicleStaffEntityDetails?id=' +
          this.vehID,
      )
      .subscribe((data) => {
        var assignStaff: any
        assignStaff = data
        if (assignStaff.status == 'ok') {
          this.delwarning = false
          this.deleteAreaEntity = true
          setTimeout(() => {
            this.deleteAreaEntity = false
            this.getAllStaffAssignmentDetails(this.Id)
            $('#myStaffEntityEntityModel').modal('hide')
          }, 1000)
        } else {
          this.delwarning = true
        }
      })
  }

  //==============To delete the VEhicles Details START===============================//
  //on select to change the staff role bind the staff Name on select index changes event.
  OnChangeToSelectStaffRole() {
    this.staffRole = this.vehStaffRoleModel
    this.getAllStaffNameByRoleId(this.staffRole)
    if (
      this.vehStaffRoleModel == null ||
      this.vehStaffRoleModel == undefined ||
      this.vehStaffRoleModel == '' ||
      this.vehStaffRoleModel == 'null'
    ) {
      this.isStaffAssignSave = true
      this.showHideStaffAssignLoadDiv = false
      this.vehStaffRoleStatus = false
      return
    } else {
      //this.vehEntityArea=false;
      this.isStaffAssignSave = true
      this.showHideStaffAssignLoadDiv = false
    }
  }

  //To check the Staff Assignment Status By Staff Drop Down List Selections
  OnChangeToSelectStaffName() {
    if (
      this.vehStaffRoleModel == null ||
      this.vehStaffRoleModel == undefined ||
      this.vehStaffNameModel == null ||
      this.vehStaffNameModel == undefined
    ) {
      this.isStaffAssignSave = true
      this.showHideStaffAssignLoadDiv = false
      return
    }
    this.showHideStaffAssignLoadDiv = true
    this.vehStaffRoleId = this.vehStaffNameModel
    this.imageStaffAssignLoader = '../../assets/img/loading.gif'
    this.http
      .get(
        environment.apiUrl +
          'admin/getVehicalStaffAssignAvailability?VEHID=' +
          this.Id +
          '&EMPROLEMAPID=' +
          this.vehStaffRoleId,
      )
      .subscribe((data) => {
        this.vehStaffAsignStatus = data
        if (this.vehStaffAsignStatus[0].result == 'Available') {
          this.isStaffAssignSave = false
          this.showHideStaffAssignLoadDiv = true
          this.imageStaffAssignLoader = '../../assets/img/ok.png'
        }
        if (this.vehStaffAsignStatus[0].result == 'Already exists') {
          this.isStaffAssignSave = true
          this.showHideStaffAssignLoadDiv = true
          this.imageStaffAssignLoader = '../../assets/img/wrong.jpg'
        }
      })
  }
  //To save the Area Asign Entity Data into the VEHENTITYMAP Table
  onClickToSaveVehStaffNameDeta() {
    this.currentDate = new Date()
    var activeStatus
    this.isStaffAssignSave = true
    this.loaderService.display(true)
    if (this.activeStatus == 'Active') {
      activeStatus = 1
    }
    if (this.vehStaffRoleModel == null || this.vehStaffRoleModel == undefined) {
      this.vehStaffRoleStatus = true
      return
    }
    if (this.vehStaffNameModel == null || this.vehStaffNameModel == undefined) {
      this.vehStaffRoleNameStatus = true
      return
    }
    var jsonAreaEntityData = {
      VEHID: this.Id,
      EMPROLEMAPID: this.vehStaffNameModel,
      ASSIGNDT: this.currentDate,
      ISACTIVE: activeStatus ? activeStatus : 0,
      ENTRYDT: this.currentDate,
      UPDATEDBY: this.userId,
    }

    //  assignment staff data in firestore database start

    this.vehService.assignmentDoc(jsonAreaEntityData)

    // assignment staff data in firestore database end

    // console.log("staff array",jsonAreaEntityData)
    this.http
      .post(
        environment.apiUrl + 'admin/saveVehStaffNameDetails',
        jsonAreaEntityData,
      )
      .subscribe((data) => {
        var staffAssignData: any
        staffAssignData = data
        if (staffAssignData.status == 'ok') {
          this.saveStaffNameStatus = true
          this.saveStaffNameError = false
          this.getAllStaffAssignmentDetails(this.Id)
          setTimeout(() => {
            this.saveStaffNameStatus = false
            this.showHideStaffAssignLoadDiv = false
            this.vehStaffRoleModel = null
            this.vehStaffNameModel = null
            this.loaderService.display(false)
          }, 1000)
        } else {
          this.saveStaffNameError = true
          this.loaderService.display(false)
        }
      })
  }

  viewHistory() {
    this.getDriverHistory()
    $('#viewHistory').modal('show')
  }

  getDriverHistory() {
    this.http
      .get(environment.apiUrl + 'admin/getDriverHistory?vehid=' + this.Id)
      .subscribe((data) => {
        this.driverHistoryData = data
        if (this.driverHistoryData.length > 0) {
          console.log(this.driverHistoryData)
        } else {
          console.log('No Data Found')
        }
      })
  }

  importVehiclesExcelReport(data) {
    const ws_name = 'VehicleReport'
    const wb: WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = utils.json_to_sheet(data)
    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary',
    })
    saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      'exported.xlsx',
    )
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff
    }
    return buf
  }

  activeStatus: any
  delete(data) {
    this.VehiclesNo = data.vehno
    $('#myModal').modal('show')
  }

  clearData() {
    this.VehiclesNo = null
    this.vehCatArea = null
    this.Id = null
    this.vehAreaModel = null
    this.vehAreaEntityModel = null
    this.vehStaffRoleModel = null
    this.vehStaffNameModel = null
    this.beatName = null
    this.areaAssignDetails = null
    this.staffAssignDetails = null
    this.driverHistoryData = null
    this.isRouteSelected = false
    this.selectedRouteId = null
  }

  assigmant(data) {
    // console.log("data",data)
    this.clearData()
    this.VehiclesNo = data.vehno
    this.vehCatArea = data.vehcatname
    this.isVehAssignSave = true
    this.isStaffAssignSave = true
    this.Id = data.ID
    this.activeStatus = data.isactive
    this.getAllAreaAssignmentDetails(this.Id)
    this.getAllStaffAssignmentDetails(this.Id)
    this.saveStaffNameError = false
    this.delwarning = false
    $('#myVehiclesAssignmtModal').modal('show')
  }

  //=================To validations for only Vehicles Catogery and Type============//
  OnChangeVehiclesCatogeryName() {
    this.getAllVehiclesType(this.vehCotId)
    if (this.vehCotId == undefined || this.vehCotId == null) {
      this.vehTypeId = null
      this.isVehicleUpdtbtn = true
      return
    }
    if (this.vehCotId != undefined || this.vehCotId != null) {
      this.isVehicleUpdtbtn = false
      return true
    }
  }
  //Vehicles Type check
  OnChangeVehiclesTypeName() {
    if (this.vehTypeId == undefined || this.vehTypeId == null) {
      this.udptVehTypename = true
      this.isVehicleUpdtbtn = true
      return
    }
    if (this.vehTypeId != undefined || this.vehTypeId != null) {
      this.udptVehTypename = false
      this.isVehicleUpdtbtn = false
      return true
    }
  }
  //restrict input only number
  public restrictNumericForVtsMobileNo(e) {
    let input
    var inputlen
    if (e.metaKey || e.ctrlKey) {
      return true
    }
    if (e.which === 32) {
      return false
    }
    if (e.which === 0) {
      return true
    }
    if (e.which < 33) {
      return true
    }
    input = String.fromCharCode(e.which)
    return !!/[\d\s]/.test(input)
  }

  OnChangeVehiclesParkLocId() {
    if (this.parkLocations == undefined || this.parkLocations == null) {
      this.udptParkLocation = true
      this.isVehicleUpdtbtn = true
      return
    }
    if (this.parkLocations != undefined || this.parkLocations != null) {
      this.udptParkLocation = false
      this.isVehicleUpdtbtn = false
      return true
    }
  }
  OnChangeDataStatus() {
    if (this.vehDataStatus == undefined || this.vehDataStatus == null) {
      this.udptDataStatus = true
      this.isVehicleUpdtbtn = true
      return
    }
    if (this.vehDataStatus != undefined || this.vehDataStatus != null) {
      this.udptDataStatus = false
      this.isVehicleUpdtbtn = false
      return true
    }
  }

  //Created by RAM on 21-08-2018
  getVtsModalData() {
    this.http
      .get(environment.apiUrl + 'admin/getVtsModalDetails?prjid=' + this.Prjid)
      .subscribe((data) => {
        this.vtsModalaData = data
      })
  }

  /*
   * On select change event VTS Modal
   */
  onChangeVtsModal(data) {
    if (data != null) {
      this.vtsData = data.VTSMODALNO
      this.vtsModelRequired = false
    } else {
      this.vtsModelRequired = true
    }
  }

  /*
   * To select the vehicle owner Type
   */
  onChangeVehTypOwner(data) {
    if (data != null) {
      this.ownerType = data.VALUE
      this.vehOwnerRequired = false
    } else {
      this.vehOwnerRequired = true
    }
  }

  /*
   *To Bind the User Active and Inactive status in drop down list
   */
  bindStatus(data) {
    //  console.log("data",data)
    this.vehStatus = data.isactive
    this.currentVehicleId = data.ID
    if (this.vehStatus == 'Active') {
      this.changeStatus = 'Inactive'
    } else {
      this.changeStatus = 'Active'
    }
  }

  /*
   * De activate Users Login
   */
  changeActiveStatus(data) {
    this.reason = data.isactive
    this.ActiveInactiveModal = '' || null
    $('#activeInactiveModal').modal('show')
  }

  SaveChangeActiveStatus() {
    if (this.vehStatus == 'Active') {
      this.status = 0
      this.titleData = 'Are you sure to Inactive this user?'
      this.successMsg = 'vehicle Status successfully.'
    } else {
      this.status = 1
      this.titleData = 'Are you sure to Active this user?'
      this.successMsg = 'vehicle Status successfully.'
    }

    this.http
      .get(
        environment.apiUrl +
          'admin/inactiveToActiveVehDetailsById?ID=' +
          this.currentVehicleId +
          '&statusId=' +
          this.status +
          '&statusReason=' +
          this.ActiveInactiveModal,
      )
      .subscribe((data) => {
        var response: any
        response = data
        var status = response.status

        if (status == 'ok') {
          this.allVehicles()

          this.vtsServiceSuccess = true
          setTimeout(() => {
            $('#activeInactiveModal').modal('hide')
            this.vtsServiceSuccess = false
          }, 1000)
        } else {
        }
      })

    // this.http
    //   .get(
    //     environment.apiUrl +
    //       'admin/inactiveToActiveVehDetailsById?ID=' +
    //       this.currentVehicleId +
    //       '&statusId=' +
    //       this.status,
    //   )
    //   .subscribe((data) => {
    //     var response: any
    //     response = data
    //     var status = response.status
    //     if (status == 'ok') {
    //       this.allVehicles()
    //       Swal(this.successMsg, 'success')
    //     } else {
    //       Swal('Error During user Active/Inactive operation!', 'error')
    //     }
    //   })
  }

  viewRouteOnMap(data) {
    $('#platAssignModal').modal('show')
    //this.googleMap(28.459497,77.026634);
    this.getMapRoute()
  }

  processPoints(this, geometry, callback, thisArg) {
    if (geometry instanceof google.maps.LatLng) {
      callback.call(thisArg, geometry)
    } else if (geometry instanceof google.maps.Data.Point) {
      callback.call(thisArg, geometry.get())
    } else {
      if (geometry) {
        geometry.getArray().forEach((g) => {
          this.processPoints(g, callback, thisArg)
        })
      }
    }
  }
  zoom(this, map, isZone) {
    this.bounds = new google.maps.LatLngBounds()
    this.map.data.forEach((feature) => {
      if (isZone) {
        this.processPoints(
          feature.getGeometry(),
          this.bounds.extend,
          this.bounds,
        )
      } else {
        if (feature.getProperty('type') == 'route') {
          this.processPoints(
            feature.getGeometry(),
            this.bounds.extend,
            this.bounds,
          )
        }
      }
    })
    map.fitBounds(this.bounds)
  }

  clearFeature() {
    this.map.data.forEach((feature) => {
      this.map.data.remove(feature)
    })
  }

  setStyle(thisRef) {
    thisRef.map.data.setStyle(function (feature) {
      var color = feature.getProperty('FillColor')
      var strokeColor = feature.getProperty('Bcolor')

      if (feature.getProperty('TYPE') == 'stopMarker') {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 2,
          fillOpacity: 0.05,
          icon: 'assets/img/stopMarker.png',
          strokeopacity: 0.2,
          label: {
            text: feature.getProperty('number'),
            color: '#FFFFFF',
            fontSize: '13px',
            background: 'yellow',
            fontWeight: 'bold',
            AlignmentVertical: 'top',
            AlignmentHorizontal: 'center',
          },
          labelClass: 'my-custom-class-for-label',
        }
      } else if (feature.getProperty('TYPE') == 'khatta') {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 5,
          fillOpacity: 0.0,
          strokeopacity: 0.2,
          icon: 'assets/img/khatta.png',
        }
      } else if (
        feature.getProperty('Oemid') == 8 ||
        feature.getProperty('Oemid') == 9 ||
        feature.getProperty('Oemid') == 10
      ) {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 3,
          fillOpacity: 0.1,
          strokeopacity: 0.8,
        }
      } else {
        return {
          fillColor: color,
          strokeColor: '#040C0A',
          strokeWeight: 4,
          fillOpacity: 0.1,
          strokeopacity: 0.4,
        }
      }
    })
  }
  getMapRoute() {
    this.clearFeature()
    this.http
      .get(
        environment.apiUrl +
          'entity/getVehicleroute?' +
          'vehId=' +
          this.currentVehicleId,
      )
      .subscribe((data) => {
        // console.log("Newdata.....",data)
        var result: any
        result = data
        this.map.data.addGeoJson(result.geoJson)
        this.zoom(this.map, true)
        this.setStyle(this)
      })
  }

  //change name to other services or actions
  otherServices(item) {
    console.log('item', item)

    /**
     * get vts services value
     * get current prjid value of veh
     *
     */

    this.vehprojectTypeListModal = item.PRJID

    console.log('item.VtsService', item.VtsService)

    this.VtsServicesValue = item.VtsService
    this.VtsServicesVehicleId = item.ID

    this.vehprojectTypeListModal = item.PRJID
    this.locationIdChange = item.PRJID

    if (item.VtsService == 1) {
      this.selectedEnabled = true
      this.selectedDisabled = false
    } else {
      this.selectedEnabled = false
      this.selectedDisabled = true
    }

    $('#vtsServiceModal').modal('show')
  }

  onChangeVtsService(e) {
    this.VtsServicesValue = e.target.value
  }

  onChangevehprojectTypeList(e) {
    this.locationIdChange = e.ID
  }

  saveVtsService() {
    var vtsJsonServiceData = {
      vehicleId: this.VtsServicesVehicleId,
      VtsServicesValue: this.VtsServicesValue,
      Prjid: this.Prjid,
      locationIdChange: this.locationIdChange,
    }

    this.http
      .post(environment.apiUrl + 'admin/saveOtherService', vtsJsonServiceData)
      .subscribe((data) => {
        this.vtsServiceSuccess = true
        setTimeout(() => {
          $('#vtsServiceModal').modal('hide')
          this.vtsServiceSuccess = false
        }, 1000)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/vehicles/vehicleMngt/vehicles.component.ts